export const iconLibrary = new Map([
  [31, () => import(`@shared/components/Icons/Icons/IconDiagrammanalyse`)],
  [32, () => import(`@shared/components/Icons/Icons/IconGewinnspiel`)],
  [
    33,
    () =>
      import(`@shared/components/Icons/Icons/IconModuleProblemloesefaehigkeit`),
  ],
  [40, () => import(`@shared/components/Icons/Icons/IconShortlist`)],
  [421, () => import(`@shared/components/Icons/Icons/IconPersoenlicheAngaben`)],
  [270200, () => import(`@shared/components/Icons/Icons/IconPersoenlichkeit`)],
  [42, () => import(`@shared/components/Icons/Icons/IconCogs`)],
  [43, () => import(`@shared/components/Icons/Icons/IconDashboard`)],
  [44, () => import(`@shared/components/Icons/Icons/IconNewsletter`)],
  [45, () => import(`@shared/components/Icons/Icons/IconProfile`)],
  [46, () => import(`@shared/components/Icons/Icons/IconTeamfaehigkeit`)],
  [
    223601,
    () =>
      import(
        `@shared/components/Icons/Icons/EligoDemo/IconAngewandtesSchlussfolgern`
      ),
  ],
  [
    225230,
    () =>
      import(`@shared/components/Icons/Icons/EligoDemo/IconDiagrammanalyse`),
  ],
  [
    224101,
    () =>
      import(
        `@shared/components/Icons/Icons/EligoDemo/IconProblemloesefaehigkeit`
      ),
  ],
  [
    224401,
    () =>
      import(
        `@shared/components/Icons/Icons/EligoDemo/IconTechnischesVerstaendnis`
      ),
  ],
  [
    24400,
    () =>
      import(
        `@shared/components/Icons/Icons/EligoDemo/IconTechnischesVerstaendnis`
      ),
  ],
  [
    24300,
    () => import(`@shared/components/Icons/Icons/IconModuleUmgangMitSprache`),
  ],
  [16002, () => import(`@shared/components/Icons/Icons/IconPersoenlichkeit`)],
  [21901, () => import(`@shared/components/Icons/Icons/IconPersoenlichkeit`)],
]);

export async function customizeIconLibrary(name) {
  if (name === 'bmwAzubiDs') {
    const iconSet = await import(`./iconSets/bmwAzubiDs`);
    iconSet.default.forEach((icon) => iconLibrary.set(icon[0], icon[1]));
  }
}
